var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrim20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_3408)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.598877,
    y: 8.79199,
    width: 5.06217,
    height: 1.20807,
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1638,
    y: 8.79199,
    width: 2.53108,
    height: 1.20807,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.45776,
    y: 8.79199,
    width: 2.53108,
    height: 1.20807,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8699,
    y: 8.79199,
    width: 2.53108,
    height: 1.20807,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.26177,
    height: 19.392,
    transform: "matrix(0.96881 0.247803 -0.270252 0.96279 9.5686 0.508423)",
    fill: "#00C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_3408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrim20);
export default __webpack_public_path__ + "static/media/trim_20.96954f4aaf4b46c97c9184b3f42db18d.svg";
export { ForwardRef as ReactComponent };